import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Input, SimpleChanges } from '@angular/core';
import { gridItem, property } from 'src/app/models';

@Component({
    selector: 'app-manual-row-sort',
    templateUrl: './manual-row-sort.component.html',
    styleUrls: ['./manual-row-sort.component.scss'],
    standalone: false
})
export class ManualRowSortComponent {
  @Input() gridItem: gridItem;
  @Input() items: any[];
  @Input() bindLabel: string;
  @Input() bindValue: string;

  public static setupPropertyName = "manualRowSortOrder";
  listItems: any[];

  get isManualRowSortEnabled(): boolean {
    return ManualRowSortComponent.getIsManualRowSortEnabled(this.gridItem);
  };

  set isManualRowSortEnabled(value: boolean) {
    // initial creation of the list
    this.gridItem.setup[ManualRowSortComponent.setupPropertyName] = value ? this.getList() : null;
  };

  constructor() { }    

  ngOnChanges(changes: SimpleChanges) {
    if (changes.items && this.items && this.isManualRowSortEnabled) {
      let getValueFn = obj => obj[this.bindValue];

      // loading from DB or state; list is already existing
      if (changes.items.currentValue && !changes.items.previousValue) {
          this.items.sort(this.sortItems.call(this, this.gridItem.setup[ManualRowSortComponent.setupPropertyName], getValueFn));        
      } else { // change of item list - add or remove items
        let oldValue : number[] = this.gridItem.setup[ManualRowSortComponent.setupPropertyName];
        this.gridItem.setup[ManualRowSortComponent.setupPropertyName] = this.getDefaultOrderedListFromItems();
        this.gridItem.setup[ManualRowSortComponent.setupPropertyName].sort(this.sortItems.call(this, oldValue));
        this.items.sort(this.sortItems.call(this, oldValue, getValueFn));
      }    
    }
  }

  drop(event: CdkDragDrop<property[]>) {
    if (event.previousIndex == event.currentIndex) return;

    moveItemInArray(this.items, event.previousIndex, event.currentIndex);
    moveItemInArray(this.gridItem.setup[ManualRowSortComponent.setupPropertyName], event.previousIndex, event.currentIndex);
  }

  getList(): number[] {
    return this.isManualRowSortEnabled ? this.gridItem.setup[ManualRowSortComponent.setupPropertyName] : this.getDefaultOrderedListFromItems();
  }

  // create list of bindValues (e.g.: ids) from items, that will be stored in setup
  // used for default ordered list, when we have no such list stored in setup
  getDefaultOrderedListFromItems(): number[] {
    return this.items.map(obj => obj[this.bindValue]);
  }

  // list - the one we get order from, the new items will be always on the top because they will have index -1
  // getValue - determines how we get the value for comparision from the row object
  sortItems(list: number[], getValue: Function = obj => obj) {
    return (itemA, itemB) => {

      let indexA = list.indexOf(getValue(itemA));
      let indexB = list.indexOf(getValue(itemB));

      return indexA - indexB;
    }
  }

  public static getIsManualRowSortEnabled(gridItem: gridItem): boolean {
    return !!gridItem?.setup[ManualRowSortComponent.setupPropertyName];
  };
}
